import { PROTOCOL_TYPE } from "../enums";
import { DlmsProtocol } from "./dlmsprotocol";

export class Protocols {
    static factory(protocolType: PROTOCOL_TYPE, payload: number[]): DlmsProtocol {
        return new DlmsProtocol(payload);
    }
}
